/* ===========================================================
   Areica — custom sections JS
   Loaded once via areica-base.liquid snippet (defer).
   =========================================================== */
(function () {
  function init() {
    /* ---- scroll reveal ---- */
    var els = document.querySelectorAll('.ar-rv:not(.ar-in)');
    if ('IntersectionObserver' in window && els.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ar-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('ar-in'); });
    }

    /* ---- product card tilt (desktop, pointer:fine only) ---- */
    if (window.matchMedia && window.matchMedia('(pointer:fine)').matches) {
      document.addEventListener('mousemove', function (e) {
        var hovered = e.target.closest ? e.target.closest('.areica-card') : null;
        document.querySelectorAll('.areica-card').forEach(function (card) {
          if (card === hovered) {
            var r = card.getBoundingClientRect();
            var rx = ((e.clientY - r.top) / r.height - 0.5) * -5;
            var ry = ((e.clientX - r.left) / r.width - 0.5) * 5;
            card.style.transform =
              'perspective(800px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateY(-4px)';
          } else {
            card.style.transform = '';
          }
        });
      });
      document.addEventListener('mouseleave', function () {
        document.querySelectorAll('.areica-card').forEach(function (c) { c.style.transform = ''; });
      });
    }

    /* ---- tabs ---- */
    document.querySelectorAll('.areica-tabs').forEach(function (tabsRoot) {
      var btns = tabsRoot.querySelectorAll('.areica-tabs__nav button');
      var panels = tabsRoot.querySelectorAll('.areica-tabs__panel');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
          btn.setAttribute('aria-selected', 'true');
          panels.forEach(function (p) {
            p.classList.toggle('show', p.getAttribute('data-panel') === btn.getAttribute('data-tab'));
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* re-init when sections are added/edited in the theme customizer */
  document.addEventListener('shopify:section:load', init);
})();
